enum ErrorCode {
  VALIDATION = 'VALIDATION',
  TWOFA_REQUIRED = 'TWOFA_REQUIRED',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVALID_2FA_OTP = 'INVALID_2FA_OTP',
  ACTIVATION = 'ACTIVATION',
  RATE_LIMIT = 'RATE_LIMIT',
}

export default ErrorCode;
